import { ShapeOptions } from '@mui/system';

export const shape: ShapeOptions = {
    borderRadius: 8,
};
